export type Message = { kind: 'ok' | 'error'; text: string } | null;

export interface Item {
  id: string;
  sku: string;
  name: string;
  unit: string;
  category: string | null;
  status: 'active' | 'inactive';
  reorderLevel: number;
  onHand: number;
  valueMinor: number;
  averageCostMinor: number;
  low: boolean;
}

export interface Supplier {
  id: string;
  name: string;
  contactPerson: string | null;
  phone: string | null;
  status: 'active' | 'inactive';
  payableMinor: number;
}

export interface Movement {
  id: string;
  itemName: string;
  sku: string;
  kind: 'receipt' | 'issue' | 'adjustment';
  quantity: number;
  valueMinor: number;
  supplierName: string | null;
  issuedTo: string | null;
  occurredOn: string;
}

export interface Asset {
  id: string;
  tag: string;
  name: string;
  category: string | null;
  location: string | null;
  status: 'in_use' | 'in_store' | 'under_repair' | 'disposed';
  custodianName: string | null;
  purchaseDate: string;
  costMinor: number;
  accumulatedMinor: number;
  netBookValueMinor: number;
}

/** A list response that also carries the school's currency (the API adds it beside `data`). */
export function withCurrency<T extends object>(res: T): T & { currency: string } {
  return { ...res, currency: (res as unknown as { currency?: string }).currency ?? 'USD' };
}
